// src/Redux/slices/eventsSlice.js
// ─── Assure-toi que ton slice contient bien ces cas ───────────────────────────
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEventsByDoctor,
  fetchEventsByDay,
  fetchEventsByRange,
  createEventForDoctor,
  deleteEvent,
  hardDeleteEvent,
} from '../thunks/eventsThunks';

const initialState = {
  list:          [],
  currentEvent:  null,
  loading:       false,
  error:         null,
  lastFilter:    null,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ── fetch by doctor ───────────────────────────────────────────────────────
    builder
      .addCase(fetchEventsByDoctor.pending,  (s) => { s.loading = true; s.error = null; })
      .addCase(fetchEventsByDoctor.fulfilled,(s, a) => {
        s.loading = false;
        // Le backend peut renvoyer { data: [...] } ou directement [...]
        s.list = Array.isArray(a.payload) ? a.payload : (a.payload?.data ?? []);
        s.lastFilter = 'doctor';
      })
      .addCase(fetchEventsByDoctor.rejected, (s, a) => { s.loading = false; s.error = a.payload; });

    // ── fetch by day ──────────────────────────────────────────────────────────
    builder
      .addCase(fetchEventsByDay.pending,  (s) => { s.loading = true; })
      .addCase(fetchEventsByDay.fulfilled,(s, a) => {
        s.loading = false;
        s.list = Array.isArray(a.payload) ? a.payload : (a.payload?.data ?? []);
        s.lastFilter = 'day';
      })
      .addCase(fetchEventsByDay.rejected, (s, a) => { s.loading = false; s.error = a.payload; });

    // ── fetch by range ────────────────────────────────────────────────────────
    builder
      .addCase(fetchEventsByRange.pending,  (s) => { s.loading = true; })
      .addCase(fetchEventsByRange.fulfilled,(s, a) => {
        s.loading = false;
        s.list = Array.isArray(a.payload) ? a.payload : (a.payload?.data ?? []);
        s.lastFilter = 'range';
      })
      .addCase(fetchEventsByRange.rejected, (s, a) => { s.loading = false; s.error = a.payload; });

    // ── create ────────────────────────────────────────────────────────────────
    // ✅ CRITIQUE : push le nouvel event dans list pour que useSelector réagisse
    builder
      .addCase(createEventForDoctor.pending,  (s) => { s.loading = true; s.error = null; })
      .addCase(createEventForDoctor.fulfilled,(s, a) => {
        s.loading = false;
        // Le backend renvoie l'event créé (ou { data: event })
        const created = a.payload?.data ?? a.payload;
        if (created?.id) {
          // Évite les doublons si le re-fetch a déjà mis à jour la liste
          const exists = s.list.some((e) => e.id === created.id);
          if (!exists) s.list.push(created);
        }
      })
      .addCase(createEventForDoctor.rejected,(s, a) => { s.loading = false; s.error = a.payload; });

    // ── delete ────────────────────────────────────────────────────────────────
    builder
      .addCase(deleteEvent.fulfilled,     (s, a) => { s.list = s.list.filter((e) => e.id !== a.payload.id); })
      .addCase(hardDeleteEvent.fulfilled, (s, a) => { s.list = s.list.filter((e) => e.id !== a.payload.id); });
  },
});

export default eventsSlice.reducer;